import React from 'react';

// Shared by the trend sections' pills and tags. Direction is carried by the
// shape, not only by the colour, so a change still reads in greyscale and in
// the printed PDF. Inherits colour from its parent via currentColor.
const TrendArrow = (props) => (
    <svg
        width={props.size || 13}
        height={props.size || 13}
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2.2'
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden='true'
    >
        {props.down ? (
            <>
                <path d='M4 8l7 7 4-4 5 5' />
                <path d='M20 16v-6' />
                <path d='M20 16h-6' />
            </>
        ) : (
            <>
                <path d='M4 16l7-7 4 4 5-5' />
                <path d='M20 8v6' />
                <path d='M20 8h-6' />
            </>
        )}
    </svg>
);

export default TrendArrow;
